import './shared/sentry';
import { syncLoqateWithVue } from './shared/loqate';
import { promptSessionExpired } from './shared/sessionExpired';

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// CSRF token from master.blade.php's meta tag. The XSRF-TOKEN cookie axios used to read is
// no longer issued (App\Http\Middleware\ValidateCsrfToken). Safe to read at import time:
// this is a module script, so the document is fully parsed before it runs, and the token
// does not change for the life of the page.
const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

if (csrfToken) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
}

// 419 means the session, and with it the token in the page, has expired. Nothing can
// succeed until the page reloads, so say so, then let the caller's own error handling run.
window.axios.interceptors.response.use(undefined, (error) => {
    if (error.response?.status === 419) {
        promptSessionExpired();
    }

    return Promise.reject(error);
});

syncLoqateWithVue();
